import { useState } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";

import DashboardHome from '../Dashboard/DashboardHome'
import Attendance from "../Attendance/Attendance";
import AttendanceReport from "../Attendance/AttendanceReport";
import ManageStudents from "../ManageStudents/ManageStudents";
import ManageStaffs from "../ManageStaffs/ManageStaffs";
import InvoiceReport from "../InvoiceReports/InvoiceReport";
import AdminConfig from "../AdminConfig/AdminConfig";
import Login from '../LoginWeb/Login'
import MasterList from '../MasterList/Masterlist'
import MasterStudent from '../MasterStudents/MasterStudent'
import MasterFees from '../MasterFees/MasterFees'
import Profile from "../Profile/Profile";
import PaymentHistory from "../PaymentHistory/PaymentHistory";
import PendingApproval from "../PendingApproval/PendingApproval";

import "./Dashboard.css";

const titleMap = {
  dashboard: "Dashboard",
  attendance: "Attendance",
  "attendance-report": "Attendance Report",
  "manage-students": "Manage Students",
  "manage-staffs": "Manage Staffs",
  "invoice-report": "Invoice Report",
  "batch-student-report": "Batch Student Report",
  "admin-config": "Admin Configuration",
  "fees": "Fees Management",
  "students": "Master Students",
  "list": "Master List",
  "profile": "My Profile",
  "payment-history": "Payment History",
  "pending-approval": "Pending Approvals"
};

const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const current = location.pathname.split("/").pop() || "dashboard";
  const title = titleMap[current] || "Dashboard";

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className={`dashboard-layout ${isSidebarOpen ? "sidebar-open" : ""}`}>
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      <div className="dashboard-main">
        <Topbar title={title} onMenuClick={toggleSidebar} />

        <div className="dashboard-content" onClick={() => isSidebarOpen && setIsSidebarOpen(false)}>
          <Routes>

            <Route 
              index 
              element={
                JSON.parse(localStorage.getItem("user") || "{}").roleName === "PARENT" 
                  ? <Navigate to="/dashboard/fees" replace /> 
                  : <DashboardHome />
              } 
            />
            {/* <Route path="dashboard" element={<DashboardHome />} /> */}
            <Route path="attendance" element={<Attendance />} />
            <Route path="manage-students" element={<ManageStudents />} />
            <Route path="manage-staffs" element={<ManageStaffs />} />
            <Route path="invoice-report" element={<InvoiceReport />} />
            <Route path="admin-config" element={<AdminConfig />} />
            <Route path="list" element={<MasterList />} />
            <Route path="students" element={<MasterStudent />} />
            <Route path="fees" element={<MasterFees />} />
            <Route path="pending-approval" element={<PendingApproval />} />
            <Route 
              path="profile" 
              element={
                JSON.parse(localStorage.getItem("user") || "{}").roleName === "PARENT" 
                  ? <Navigate to="/dashboard/fees" replace /> 
                  : <Profile />
              } 
            />
            <Route 
              path="payment-history" 
              element={
                JSON.parse(localStorage.getItem("user") || "{}").roleName === "PARENT" 
                  ? <PaymentHistory /> 
                  : <Navigate to="/dashboard" replace />
              } 
            />

          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
